module.exports = __webpack_public_path__ + "img/service.61551b45.svg";